import { useEffect, useCallback, useRef, useState } from 'react'
import { useLeafletContext } from '@react-leaflet/core'
import vectorTileLayer from 'leaflet-vector-tile-layer';



export default function VectorLayerSelected(props) {
    // Explanation https://javascript.plainenglish.io/creating-an-ellipse-in-react-leaflet-72e2c5beff03


    function handlePolygonClick(e) {
        console.log(e.sourceTarget.properties)
        props.setDashboardData(e.sourceTarget.properties)
        if (props.type === "flurstueckflaechen") {
            props.setSelectedPolygonId(e.sourceTarget.properties.flurstid)
        } else if (props.type === "forsteinrichtungsflaechen") {
            props.setSelectedPolygonId(e.sourceTarget.properties.id)
        } else if (props.type === "arnsberg") {
            props.setSelectedPolygonId("arnsberg")
        }
    }

    const context = useLeafletContext()
    const options = {
        style: function (e) {
            // Use different style if layer is selected
            let idProperty;
            if (props.type === "flurstueckflaechen") {
                idProperty = e.properties.flurstid
            } else if (props.type === "forsteinrichtungsflaechen") {
                idProperty = e.properties.id
            } else if (props.type === "arnsberg") {
                idProperty = "arnsberg"
            }
            if (props.selectedPolygonId === idProperty) {
                return {
                    fill: false,
                    stroke: true,
                    color: props.color,
                    weight: 3
                }
            }
            else {
                return {
                    fill: true,
                    fillOpacity: 0,
                    stroke: false
                }
            }
        }


    };
    const layerRef = useRef()


    useEffect(() => {
        const container = context.layerContainer || context.map
        layerRef.current = vectorTileLayer(props.url, options);
        layerRef.current.setZIndex(10001)
        container.addLayer(layerRef.current)

        layerRef.current.on("click", function (e) {
            handlePolygonClick(e)
        })

        return () => {
            container.removeLayer(layerRef.current)
        }
    }, [])

    // useEffect(() => {
    //     layerRef.current.setOpacity(props.layerSelection.opacity)
    //     // propsRef.current = props
    //   }, [props.layerSelection.opacity])

    return null




}

